import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import NothingToShow from "../fields/NothingToShow";

import FieldLabel from "./FieldLabel";

export default function ProviderField({ label, data, renderValue }) {
  const isEmpty = data === null || data === undefined || (Array.isArray(data) && data.length === 0);

  return (
    <div className="flex flex-col">
      <FieldLabel value={label} />

      {isEmpty ? (
        <NothingToShow />
      ) : (
        <Typography className="text-[14px]" sx={{ color: HNSColors.neutrals[100] }}>
          {renderValue ? renderValue(data) : data}
        </Typography>
      )}
    </div>
  );
}
